import React from 'react'
import FlashDurationSelector from '../Selector/FlashDurationSelector'
import FlashSelector from '../Selector/FlashSelector'
import { useTranslation } from '@/hooks/useTranslation';
import EnabledHazardsSelector from '../Selector/EnabledHazardsSelector';
import HazardsPerRoundSelector from '../Selector/HazardsPerRoundSelector';
import HazardSelector from '../Selector/HazardSelector';
import CompassSelector from '../Selector/CompassSelector';
import { useGame } from '@/app/providers/GameContextProvider';
import { GameMode } from '@/lib/types/common/GameMode';

const ChallengeConfig = ({
    forceFlash = false,
    forceHazards = false,
    showFlash = true,
    showHazards = true
}) => {
    const { gameState } = useGame();
    const { t } = useTranslation();

    const hasFlash = gameState?.gameMode === GameMode.FLASH || gameState?.gameSettings.hasFlashMode;
    const hasHazards = gameState?.gameMode === GameMode.HAZARD || gameState?.gameSettings.hasHazards;

    return (
        <div className="flex flex-col">
            <div className="text-shadow-border shadow-black text-xl">{t('game.config.advancedSettings.challenge')}</div>
            <div className="flex flex-col gap-1 ml-3">
                {showFlash && (
                    <>
                        {!forceFlash && <FlashSelector />}
                        {hasFlash && (<FlashDurationSelector />)}
                    </>
                )}
                {showHazards && (
                    <>
                        {!forceHazards && <HazardSelector />}
                        {hasHazards && (
                            <>
                                <HazardsPerRoundSelector />
                                <EnabledHazardsSelector />
                            </>
                        )}
                    </>
                )}
                <CompassSelector />
            </div>
        </div>
    )
}

export default ChallengeConfig